import { render, staticRenderFns } from "./SubMenuPopup.vue?vue&type=template&id=79377091"
import script from "./SubMenuPopup.vue?vue&type=script&lang=js"
export * from "./SubMenuPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports